import React from 'react';
import {Icon} from '@iconify/react';
import './styles/errorModalIcon.scss';

interface ErrorModalIconProps {
    className?: string;
    icon?: string | JSX.Element;
}

function ErrorModalIcon({icon, className}: ErrorModalIconProps): JSX.Element {
    return <Icon className={`${className || 'c-errorModalIcon'}`} icon={`${icon || 'carbon:warning-alt-filled'}`} />;
}

export default ErrorModalIcon;
